import {SelectMore} from './components/SelectMore';
import {SelectAllEntrySvg} from '@/icons';
import Icon from '@/components/Icon';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import './sidebarSelectMore.scss';
import * as store from '@/store';
import {useIntl} from 'react-intl';
import {Popper, PopperTrigger} from '@baidu/luffy-comp-popper';
import {useCallback, useEffect, useRef, useState} from 'react';
import sdk from '@/sdk';
import {DragOption} from '@/interface';
import {clickEnterSelectBatch, feLogger} from '@/buried';

interface sidebarSelectAllPros {
    isTreeBatchOperate?: boolean;
    sidebarDragOption?: DragOption;
}
interface INewGuide {
    onClose:()=>void;
}

const NewGuide:React.FC<INewGuide> = ({onClose: handleClose}) => {
    const intl = useIntl();
    return (
        <div
            className={'sidebar-sidebarSelectMore-guideRoot'}
            onClick={(ev: React.MouseEvent<HTMLDivElement>) => ev.stopPropagation()}
        >
            <div className={'sidebar-sidebarSelectMore-guideWord'}>
                {intl.formatMessage({id: 'batchOperateNewGuide'})}
            </div>
            <div className={'sidebar-sidebarSelectMore-closeBtn'} onClick={handleClose}>
                我知道了
            </div>
        </div>
    );
};

function SidebarSelectMore(props: sidebarSelectAllPros) {
    const {isTreeBatchOperate: sidebarSelectAll, sidebarDragOption} = props;
    const selectBatchOperateIsRead = sdk.as.user?.settings?.newGuide?.selectBatchOperateIsRead;
    const target = useRef<any>();
    const [guideVisible, setGuideVisible] = useState(false);


    const handleCloseGuide = useCallback(() => {
        setGuideVisible(false);
        sdk.as.updateNewGuide({
            selectBatchOperateIsRead: true,
        }).catch(err => console.error(err));
    }, []);
    function handleClickIcon() {
        store.setSidebarSelectBatch(true);
        handleCloseGuide();
        feLogger(clickEnterSelectBatch());
    }

    function onCloseSelect() {
        store.setSidebarSelectBatch(false);
    }

    useEffect(() => {
        if (selectBatchOperateIsRead) {
            return;
        }
        if (sidebarDragOption?.sidebarOpen) {
            setGuideVisible(true);
        } else {
            setGuideVisible(false);
        }
    }, [selectBatchOperateIsRead, sidebarDragOption]);

    return (<div
        className="sidebar-selectMore"
    >
        <SelectMore
            visible={!!sidebarSelectAll}
            onCloseSelect={onCloseSelect}
        />

        {
            sidebarSelectAll
                ? null
                : <PopperTrigger visible={guideVisible} target={target.current}>
                    <Tooltip
                        trigger={TooltipTrigger.Hover}
                        content={'批量操作'}
                        placement="top"
                    >
                        <div
                            onClick={handleClickIcon}
                            ref={target}
                            className="sidebar-sidebarSelectMore-icon"
                        >
                            <Icon
                                svg={SelectAllEntrySvg}
                            />
                        </div>
                    </Tooltip>
                    <Popper
                        className={'sidebar-sidebarSelectMore-Popover'}
                        withArrow
                        placement="bottom"
                        preventOverflowBoundary="viewport"
                    >
                        <NewGuide onClose={handleCloseGuide} />
                    </Popper>
                </PopperTrigger>
        }
    </div>);
}


export default store.connect([
    store.KEYS.IS_TREE_BATCH_OPERATE,
    store.KEYS.TREE_SELECTED_OBJ,
    store.KEYS.SIDE_BAR_DRAG_OPTION,
])(SidebarSelectMore);
